<svg id="Group_2_Copy_11" data-name="Group 2 Copy 11" xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26">
  <rect id="Rectangle" width="32" height="26" rx="1.6" fill="#c6b0e9"/>
  <g id="Group_38" data-name="Group 38" transform="translate(3.4 5.9)">
    <g id="Group_26" data-name="Group 26">
      <rect id="Rectangle-2" data-name="Rectangle" width="25.2" height="5.2" rx="0.4" fill="#713ac9"/>
      <rect id="Rectangle-3" data-name="Rectangle" width="25.2" height="5.2" rx="0.4" transform="translate(0 9)" fill="#713ac9"/>
      <rect id="Rectangle_Copy_38" data-name="Rectangle Copy 38" width="4" height="2.8" rx="0.4" transform="translate(1.9 1.2)" fill="#c6b0e9"/>
      <rect id="Rectangle_Copy_38-2" data-name="Rectangle Copy 38" width="4" height="2.8" rx="0.4" transform="translate(19.3 10.2)" fill="#c6b0e9"/>
    </g>
  </g>
</svg>
